import BrandArticlesInner from '../snippets/brand-articles-inner';

const initializeBrandArticles = (section) => {
  const sectionEl = document.querySelector(`#shopify-section-${section.id}`);
  const snippetEl = sectionEl.querySelector('.fs-brand-articles-inner');
  BrandArticlesInner.initializeBrandArticles(snippetEl, section.collectionTitle);
};

const brandArticlesMain = () => {
  if (!window.fstore.sections) {
    return;
  }
  window.fstore.sections.forEach((section) => {
    if (section.sectionType == 'brand-articles') {
      initializeBrandArticles(section);
    }
  });
};

addEventListener('DOMContentLoaded', (event) => {
  brandArticlesMain();
});
